export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-secondary-900">
      <div className="max-w-[1000px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-14">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading text-background-50 mb-4">
              移动观影 · 随时随地看好片
            </h2>
            <p className="text-background-400 text-sm md:text-base leading-relaxed mb-6 max-w-lg mx-auto lg:mx-0">
              555影视全面适配移动端浏览器，无需下载安装任何应用，打开手机浏览器即可畅享最新电影高清在线观看。无论您在地铁、午休还是旅途中，流畅播放不缓冲的观影体验始终相伴。
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4">
              <div className="flex items-center gap-2 px-5 py-3 rounded-xl bg-background-50/10 text-background-200 cursor-pointer whitespace-nowrap">
                <i className="ri-smartphone-line text-xl"></i>
                <span className="text-sm">手机浏览器直达</span>
              </div>
              <div className="flex items-center gap-2 px-5 py-3 rounded-xl bg-background-50/10 text-background-200 cursor-pointer whitespace-nowrap">
                <i className="ri-tablet-line text-xl"></i>
                <span className="text-sm">平板同样适配</span>
              </div>
            </div>
          </div>
          <div className="flex-shrink-0">
            <div className="relative w-56 h-96 rounded-3xl overflow-hidden border-4 border-background-200/30">
              <img
                src="https://readdy.ai/api/search-image?query=A%20modern%20smartphone%20screen%20displaying%20a%20cinematic%20movie%20browsing%20interface%20with%20warm%20dark%20theme%2C%20elegant%20film%20poster%20thumbnails%20grid%2C%20minimalist%20UI%20design%2C%20soft%20ambient%20glow%2C%20no%20text%20no%20logos%20no%20recognizable%20faces%2C%20sleek%20modern%20aesthetic&width=560&height=960&seq=app-mobile-mockup&orientation=portrait"
                alt="555影视移动端观影体验"
                className="w-full h-full object-cover"
                onError={(e) => {
                  (e.target as HTMLElement).style.display = 'none';
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}